import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { SelectInput } from '../Inputs/Inputs'

import styles from '../../../../css/devicePage.module.css'
import stylesSettings from '../../../../css/settings.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

const IsActive = ({ device }) => {
  const {
    is_active: isActive = true,
  } = device || {}

  const [isActiveState, setIsActiveState] = useState(isActive)

  const appDispatch = useCallback(() => {
    const { id: deviceID } = device

    AppDispatcher.dispatch({
      action: 'change-device',
      deviceID,
      data: {
        is_active: isActiveState,
      },
    })
  }, [isActiveState, device])

  useEffect(() => {
    appDispatch()
  }, [isActiveState])

  const childChange = useCallback((event) => {
    setIsActiveState(event.target.value === 'true')
  }, [])

  const groupOptions = [
    { value: true, name: 'Active' },
    { value: false, name: 'Inactive' },
  ]

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          Device Status
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={isActiveState}
            childChange={childChange}
            field='isActive'
            options={groupOptions}
            style={stylesSettings.ruleSelectInput}
          />
        </div>
      </section>
    </div>
  )
}

IsActive.propTypes = {
  device: PropTypes.object.isRequired,
  customer: PropTypes.object.isRequired,
}

export default IsActive
